// Holds useful functions

export default {
    clone: function (data) {
        return JSON.parse ( JSON.stringify (data) )
    },

    // The de-facto unbiased shuffle algorithm is the Fisher-Yates (aka Knuth) Shuffle.
    // See https://github.com/coolaj86/knuth-shuffle
    // Modifies original array
    shuffle: function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    },

    replaceAll: function (string, target, replaceWith) {
        let i = 0;
        let end = string.length;
        let newString = string;

        while (newString.includes (target)) {
            newString = newString.replace (target, replaceWith)
        }

        return newString;
    }
}
